// Types
import type { TApiHttpClientRequestConfig } from '~/misc/resource/types';
import type {
  TUser,
  TNewUser,
  TPaginatedUsers,
  TUserIndexPayload,
  IUserResourceModel,
} from '~/misc/user-resource/types';

// Models
import { ManagerResource } from '~/modules/manager/resource/manager-resource.model';
import { ManagerUserModel } from '~/modules/manager/models/user';

export class ManagerUserResourceAdapter extends ManagerResource implements IUserResourceModel {
  constructor(
    protected companyId: number,
    protected model: ManagerUserModel = new ManagerUserModel()
  ) {
    super();
  }

  index(
    payload: TUserIndexPayload,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<TPaginatedUsers> {
    return this.model.index(this.companyId, payload, requestConfig);
  }

  show(id: number, requestConfig?: TApiHttpClientRequestConfig): Promise<TUser> {
    return this.model.show(id, requestConfig);
  }

  store(payload: TNewUser, requestConfig?: TApiHttpClientRequestConfig): Promise<TUser> {
    return this.model.store(this.companyId, payload, requestConfig);
  }

  update(
    id: number,
    payload: TNewUser,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<TUser> {
    return this.model.update(id, payload, requestConfig);
  }

  destroy(id: number, requestConfig?: TApiHttpClientRequestConfig): Promise<void> {
    return this.model.destroy(id, requestConfig);
  }
}
